import React, { useContext, useState, useEffect } from 'react'

import Navbar from 'react-bootstrap/Navbar';

import {
    BrowserRouter as Router,
    Route,
    Routes,
} from "react-router-dom";

import { UiContext } from '../context/UiContext';

import { SideMenu } from '../components/sideMenu';
import { Salir } from '../components/salir';
import { getUsuarioStorage } from '../helpers/getUsuarioStorage';
import { serverApi } from '../api';

import { Cola } from './Cola';
import { Cola2 } from './Cola2';
import { CrearTicket } from './CrearTicket';
import { CrearTicketV2 } from './CrearTicketV2';
import { Modulo } from './ModuloAtencion/Modulo';
import { Informes } from './Informes/Informes';
import { NuevoDashboard } from './Informes/NuevoDashboard';
import { ListaPacientes } from './Informes/Lista-Pacientes';
import { Ingreso } from './Ingreso';
import { EnBlanco } from './EnBlanco';
import { ModuloConsultorio } from './ModuloConsultorio/ModuloConsultorio';
import { UsuariosPage } from './Usuarios/UsuariosPage';
import { ModulosTipoAtencionPage } from './Modulos/Modulos-TiposAtencion';
import { ModulosCreacion } from './Modulos/Modulos-Creacion';
import { TiposAtencionPage } from './TiposAtencion/TiposAtencionPage';
import { VideosAdmin } from './Videos-Admin/Videos-Admin';
import { UbicacionesCreacion } from './Ubicaciones/Ubicaciones-Creacion';
import { SuperAdminLogin } from './SuperAdmin/SuperAdminLogin';
import { SuperAdminPanel } from './SuperAdmin/SuperAdminPanel';
import { VendedorPanel } from './SuperAdmin/VendedorPanel';
import { CallScreen } from './CallScreen';
import { MiEmpresaPage } from './MiEmpresaPage';

export const RouterPage = () => {

    const { ocultarMenu } = useContext(UiContext);

    const [collapsed, setCollapsed] = useState(false);
    const [toggled, setToggled] = useState(false);

    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {

        const handleResize = () => {
            setIsMobile(window.innerWidth < 768);

            if (window.innerWidth >= 768) {
                setToggled(false);
            }
        };

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);

    }, []);

    return (

        <Router>

            <div className="app-layout">


                {
                    !ocultarMenu &&
                    (
                        <SideMenu
                            collapsed={collapsed}
                            toggled={toggled}
                            setToggled={setToggled}
                        />
                    )
                }

                <main
                    className={`main-content ${collapsed ? 'collapsed-content' : ''}`}>

                    {
                        !ocultarMenu &&
                        (() => {
                            const usuarioStorage = getUsuarioStorage();
                            const logoPath = usuarioStorage.imagenLogo || usuarioStorage.imagenIcono;
                            const fullLogoUrl = logoPath
                                ? (logoPath.startsWith('http') ? logoPath : `${serverApi.defaults.baseURL.replace('/api', '')}${logoPath}`)
                                : null;

                            return (
                                <Navbar className="top-navbar px-3 d-flex justify-content-between align-items-center">

                                    <div className="d-flex align-items-center gap-3">

                                        <button
                                            className="menu-btn"
                                            onClick={() => {
                                                if (isMobile) {
                                                    setToggled(!toggled);
                                                } else {
                                                    setCollapsed(!collapsed);
                                                }
                                            }}
                                        >
                                            <i className="fa-solid fa-bars"></i>
                                        </button>

                                        {/* Branding de Empresa en Navbar Principal */}
                                        {(fullLogoUrl || usuarioStorage.nombreEntidad) && (
                                            <div className="d-flex align-items-center gap-2 ms-2 ps-2 border-start border-2">
                                                {fullLogoUrl && (
                                                    <img
                                                        src={fullLogoUrl}
                                                        alt="Logo Empresa"
                                                        style={{ maxHeight: 36, maxWidth: 150, objectFit: 'contain' }}
                                                        onError={(e) => { e.target.style.display = 'none'; }}
                                                    />
                                                )}
                                                {usuarioStorage.nombreEntidad && (
                                                    <span className="fw-bold fs-6 text-dark mb-0">
                                                        {usuarioStorage.nombreEntidad}
                                                    </span>
                                                )}
                                            </div>
                                        )}

                                    </div>

                                    <Salir />

                                </Navbar>
                            );
                        })()
                    }

                    <div className="page-container">

                        <Routes>
                            <Route path='/cola' element={<Cola />} />
                            <Route path='/cola2' element={<Cola2 />} />
                            <Route path='/callscreen' element={<CallScreen />} />
                            <Route path='/crear' element={<CrearTicket />} />
                            <Route path='/crear2' element={<CrearTicketV2 />} />
                            <Route path='/modulo' element={<Modulo />} />
                            <Route path='/informes' element={<Informes />} />
                            <Route path='/nuevo-dashboard' element={<NuevoDashboard />} />
                            <Route path='/lista-Pacientes' element={<ListaPacientes />} />
                            <Route path='/inicio' element={<EnBlanco />} />
                            <Route path='/*' element={<Ingreso />} />

                            <Route path='/consultorio' element={<ModuloConsultorio />} />
                            <Route path='/tiposAtencion' element={<TiposAtencionPage />} />
                            <Route path='/ubicaciones' element={<UbicacionesCreacion />} />

                            <Route path='/modulos-creacion' element={<ModulosCreacion />} />
                            <Route path='/modulos-tiposAtencion' element={<ModulosTipoAtencionPage />} />
                            <Route path='/videos-admin' element={<VideosAdmin />} />
                            <Route path='/usuarios' element={<UsuariosPage />} />
                            <Route path='/mi-empresa' element={<MiEmpresaPage />} />

                            {/* Rutas SuperAdmin y Vendedores */}
                            <Route path='/superadmin' element={<SuperAdminLogin />} />
                            <Route path='/superadmin/dashboard' element={<SuperAdminPanel />} />
                            <Route path='/vendedor/dashboard' element={<VendedorPanel />} />

                        </Routes>

                    </div>

                </main>

            </div>

        </Router>
    )
}